import application from 'application/application';

import templateUrl from './module-people.template.html';

import controller from './module-people.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.default.module-peoples', {
			url: '/pessoas',
			views: {
				'default@root.default': { templateUrl, controller }
			},
			data: {
				documentTitle: 'Pessoas'
			}
		});
	}
]);
